module.exports = __webpack_public_path__ + "static/media/web_lazy-ux@2x.82747ce6.png";